<template>

    <m-edit1/>

    <m-single-category-302 v-bind='{...{"is_digital":"","title":"","firstCategory":"\u0622\u062e\u0631\u06cc\u0646 \u0645\u062d\u0635\u0648\u0644\u0627\u062a","digitalShoppingCartBadge":"\u0645\u0634\u0627\u0647\u062f\u0647 \u0648 \u062e\u0631\u06cc\u062f","physicalShoppingCartBadge":"\u0645\u0634\u0627\u0647\u062f\u0647 \u0648 \u062e\u0631\u06cc\u062f"},...{}}' :style='""' class="" ></m-single-category-302>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleCategory302 from '@moeinmdn/miw-alpha-components/src/package/Category/Single/SingleCategory302';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleCategory302 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
